import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Storage {
      editorid: { editorid: string };
   }
}

export const Editorid = Extension.create({
   name: 'editorid',

   addStorage() {
      return {
         editorid: null,
      };
   },

   onCreate() {
      this.storage.editorid = this.options.editorid;
   },
});
